import React from "react";
import {ConfirmModal} from "../utils/Modal";
import Button from "@mui/material/Button";

export default class ActionIsolation extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            action: props.actions[props.userId][0],
            show: false
        };
        this.canIncreaseValue = this.canIncreaseValue.bind(this);
        this.canDecreaseValue = this.canDecreaseValue.bind(this);
        this.increaseValue = this.increaseValue.bind(this);
        this.decreaseValue = this.decreaseValue.bind(this);
    }

    componentDidMount() {
    }

    canIncreaseValue(){
        let value = this.state.action.nbHeatProduction;
        return this.props.actions[this.props.userId].some(a => a.nbHeatProduction === value + 1);
    }

    canDecreaseValue(){
        let value = this.state.action.nbHeatProduction;
        return this.props.actions[this.props.userId].some(a => a.nbHeatProduction === value - 1);
    }

    increaseValue(){
        let value = this.state.action.nbHeatProduction;
        let newAction = this.props.actions[this.props.userId].filter(a => a.nbHeatProduction === value + 1)[0];
        if(newAction){
            this.setState({action: newAction});
        }
    }

    decreaseValue(){
        let value = this.state.action.nbHeatProduction;
        let newAction = this.props.actions[this.props.userId].filter(a => a.nbHeatProduction === value - 1)[0];
        if(newAction){
            this.setState({action: newAction});
        }
    }

    render() {
        let modal = <ConfirmModal
            action={this.state.show ? this.state.action : undefined}
            text={"Voulez-vous échanger " + this.state.action.nbHeatProduction + " production de chaleur ?"}
            socket={this.props.socket}
            onDismiss={() => this.setState({show: false})}
            open={this.state.show}
        />;
        return <div
            style={{
                margin: "0", overflow: "hidden", width: "100%", height: "100%", color: "#DDD",
                display: "flex", flexDirection: "column"
            }}>
            {modal}
            <div style={{flex: 1, fontSize: "20px", alignItems: "center", display: "flex", marginLeft: "20px"}}>
                Combien de production de chaleur voulez-vous échanger ?
            </div>
            <div style={{flex: 1, width: "100%", display: "flex", flexDirection: "row", margin: "5vh 0"}}>
                <div style={{flex: 1, display: "flex", justifyContent:"center", alignItems:"center"}}>
                    <Button onClick={() => this.decreaseValue()}
                            disabled={!this.canDecreaseValue()}
                            variant={"contained"}
                    >
                        -
                    </Button>
                </div>
                <div style={{flex: 1, display: "flex", justifyContent:"center", alignItems:"center", fontSize: "20px", height: "100%"}}>
                    {this.state.action.nbHeatProduction}
                    <img
                        style={{height: "auto", marginLeft: "8px", width: "60%"}}
                        src={"/public/terraforming/icons/prod_heat.png"} alt="card"/>
                </div>
                <div style={{flex: 1, display: "flex", justifyContent:"center", alignItems:"center"}}>
                    <Button onClick={() => this.increaseValue()}
                            disabled={!this.canIncreaseValue()}
                            variant={"contained"}
                    >
                        +
                    </Button>
                </div>
            </div>
            <div style={{flex: 1, fontSize: "20px", alignItems: "center", display: "flex", justifyContent: "center"}}>
                <Button onClick={() => this.setState({show: true})}
                        variant={"contained"}
                >
                    Echanger
                </Button>
            </div>
        </div>
    }
}
